import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageTitle from '../../Components/PageTitle';
import { images } from '../../assets/images';
import { routes } from '../../routes';
import ProductController from '../../apis/controller/ourProducts.controller';
import { charLimit, stripTags } from '../../Components/helper/General';
import { renderImage } from '../../Components/helper/image';

function Product() {
    const [productList, setProductList] = useState();
    const [breadCrumbs, setBreadcrumbs] = useState();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getProducts();
        window.scrollTo(0, 0);

    }, []);

    const getProducts = async () => {
        setLoader(true);
        let res = await new ProductController().productsListing();
        if (res && res.status) {
            setProductList(res.products);
            setBreadcrumbs(res.breadcrumb);
        }
        setLoader(false);
    };
    return (
        <>
            {breadCrumbs ? <PageTitle title={breadCrumbs.main_title} image={breadCrumbs.image} /> : null}
            <section className="products_section bg-light pt-5 pb-5">
                {productList && <div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="products_area el">
                                <div className="products_items">
                                    { <div className="row ">
                                        {productList.map((item, index) => (
                                            <div key={index} className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                                <div className="product_item">
                                                    <div className="product_img">
                                                        <img src={item.image && item.image.length > 0 ? renderImage(item.image[0], 'medium') : images.noimage} alt="..." className="img-fluid d-block mx-auto" />
                                                    </div>
                                                    <div className="product_info">
                                                        <h4>{item.title}</h4>
                                                        <div dangerouslySetInnerHTML={{ __html: charLimit(stripTags(item.description), 100) }} />
                                                        {/* <p>{charLimit(stripTags(item.description), 120)}</p> */}
                                                        <div className="upper_image">
                                                            <div className="secondary_btn text-center">
                                                                <Link to={{
                                                                    pathname: `/productdetail/${item.slug}`,
                                                                    id: item.id
                                                                }}>View Details <i className="far fa-angle-right"></i></Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                   }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </section>
        </>
    );
}

export default Product;